import { render, staticRenderFns } from "./ClientEventProcedureItemV2.vue?vue&type=template&id=7f44c390&scoped=true"
import script from "./ClientEventProcedureItemV2.vue?vue&type=script&lang=js"
export * from "./ClientEventProcedureItemV2.vue?vue&type=script&lang=js"
import style0 from "./ClientEventProcedureItemV2.vue?vue&type=style&index=0&id=7f44c390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f44c390",
  null
  
)

export default component.exports